function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

module.exports = _taggedTemplateLiteralLoose;


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/yup/~/@babel/runtime/helpers/taggedTemplateLiteralLoose.js
// module id = 1854
// module chunks = 3 9